import { Button } from "@/components/ui/button";
import { ArrowRight, CheckCircle2, Gift, Sparkles } from "lucide-react";
import { Footer } from "@/components/layout/Footer";
import { Link } from "react-router-dom";

export default function ThankYouPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-grow bg-gradient-to-b from-white to-gray-50">
        <div className="container mx-auto px-4 py-8">
          <div className="max-w-4xl mx-auto">
            <Link to="/" className="flex items-center justify-center mb-12">
              <span className="text-lawyer-primary font-display font-bold text-5xl dark:text-white">
                Lex<span className="text-lawyer-secondary">Prompt</span>
              </span>
            </Link>
          </div>
        </div>

        <div className="container mx-auto px-4 py-8">
          <div className="max-w-4xl mx-auto text-center">
            <div className="mb-8">
              <Sparkles className="w-16 h-16 text-lawyer-secondary mx-auto mb-4" />
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
                Parabéns pela sua compra!
              </h1>
              <p className="text-xl text-gray-600 mb-8">
                Você deu o primeiro passo para revolucionar sua prática jurídica com IA
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">
                Próximos passos:
              </h2>
              <div className="space-y-4 text-left">
                <div className="flex items-start gap-4">
                  <CheckCircle2 className="w-6 h-6 text-green-500 mt-1 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-lg mb-1">Acesse seu eBook</h3>
                    <p className="text-gray-600">
                      Verifique seu e-mail para acessar o material completo
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <CheckCircle2 className="w-6 h-6 text-green-500 mt-1 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-lg mb-1">Entre em contato</h3>
                    <p className="text-gray-600">
                      Nossa equipe está pronta para ajudar você a aproveitar ao máximo o material
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-lawyer-primary/5 p-8 rounded-2xl border border-lawyer-primary/20 mb-12">
              <Gift className="w-12 h-12 text-lawyer-secondary mx-auto mb-4" />
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Bônus Exclusivo!
              </h2>
              <p className="text-lg text-gray-600 mb-6">
                Cadastre-se gratuitamente no LexPrompt e ganhe acesso a:
              </p>
              <ul className="text-left space-y-3 mb-8 max-w-md mx-auto">
                <li className="flex items-center text-gray-700">
                  <CheckCircle2 className="w-5 h-5 text-lawyer-secondary mr-2" />
                  Prompts adicionais exclusivos
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle2 className="w-5 h-5 text-lawyer-secondary mr-2" />
                  Atualizações em tempo real
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle2 className="w-5 h-5 text-lawyer-secondary mr-2" />
                  Comunidade de advogados
                </li>
              </ul>
              <Button
                size="lg"
                className="m-auto flex items-center gap-2 bg-[#072a45] hover:bg-[#072a45] dark:bg-[#d4af37] dark:hover:bg-[#d4af37] text-white dark:text-[#072a45]"
                onClick={() => window.location.href = "https://lexprompt.decidedigital.com.br/"}
              >
                Cadastre-se Grátis
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
} 